var _circle, _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangesUnavailableIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#C5E3FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7406_101418",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 56,
    width: 12,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9498 56.0879H47.0502V66.5007H36.9498V56.0879Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7406_101418)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0502 61.2944C47.0502 64.1699 44.7888 66.501 41.9995 66.501C39.2102 66.501 36.9498 64.1699 36.9498 61.2944C36.9498 58.419 39.2102 56.0879 41.9995 56.0879C44.7888 56.0879 47.0502 58.419 47.0502 61.2944Z",
    fill: "#0E5CF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7406_101418",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 17,
    width: 14,
    height: 35
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8748 17.499H48.1248V51.6249H35.8748V17.499Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7406_101418)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1719 46.6483C37.1719 49.3967 39.3334 51.6249 41.9995 51.6249C44.6665 51.6249 46.8279 49.3967 46.8279 46.6483L48.125 23.8136C48.125 20.3262 45.3825 17.499 41.9995 17.499C38.6174 17.499 35.8748 20.3262 35.8748 23.8136L37.1719 46.6483Z",
    fill: "#0E5CF4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangesUnavailableIcon);
export default __webpack_public_path__ + "static/media/changes-unavailable-icon.75a911076b6231087a33942808f651c4.svg";
export { ForwardRef as ReactComponent };